import React from "react";
import Svg, { Circle, Path } from "react-native-svg";

export default function SvgProfile() {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <Circle cx="12" cy="8" r="3.5" stroke="#000" strokeWidth="1.8" />
      <Path
        d="M5.5 19c1.3-3.1 3.8-4.7 6.5-4.7s5.2 1.6 6.5 4.7"
        stroke="#000"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </Svg>
  );
}
